module.exports = "/_next/static/images/d37796f5988196223437dba4d30d2dd1-LogoPaypal.jpg";